import useLocalStore from '../../../hooks/useLocalStore.js';
import FJCreateVoiceCloning from '../view/FJCreateVoiceCloning.jsx';
import { useSelector, useDispatch } from 'react-redux';
import FJActionVoiceCloning from '../../../redux/action/FJActionVoiceCloning.js';
import FJConstant from '../../../constants/FJConstant.js';
import FJActionModal from '../../../redux/action/FJActionModal.js';
import FJAudioPlayManager from '../../../store/FJAudioPlayManager.js';
const FJCreateVoiceCloningContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const createCloneStatus = useSelector(state => state.voiceCloning.createCloneStatus);
    const profileId = useSelector(state => state.voiceCloning.profileId);
    const voiceName = useSelector(state => state.voiceCloning.voiceName);
    const selectedLang = useSelector(state => state.voiceCloning.selectedLang);
    const audioUrl = useSelector(state => state.voiceCloning.audioUrl);
    const audioName = useSelector(state => state.voiceCloning.audioName);
    const previewAudioUrl = useSelector(state => state.voiceCloning.previewAudioUrl);
    const historyList = useSelector(state => state.common.historyList);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const hasHistoryList = !!(historyList && historyList.length);
    const freeNumCreationOfVoiceClone = useSelector(state => state.textToSpeech.freeNumCreationOfVoiceClone);
    const isUploading = useSelector(state => state.voiceCloning.isUploading);

    const _uploadAudioInVoiceClone = file => {
        dispatch(FJActionVoiceCloning.uploadAudioInVoiceCloneAction(file, { source: 'up' }));
    };

    const _onChangeProfile = profileId => {
        dispatch(FJActionVoiceCloning.setProfileAction(profileId));
    };

    const _onChangeVoiceName = value => {
        dispatch(FJActionVoiceCloning.setVoiceNameAction(value));
    };

    const _onChangeLang = lang => {
        dispatch(FJActionVoiceCloning.setSelectedLangAction(lang));
    };

    const _onGenerate = () => {
        FJAudioPlayManager.pauseAll();
        dispatch(FJActionVoiceCloning.onGenerateAction());
    };

    const _goHistory = () => {
        dispatch(FJActionVoiceCloning.resetAction());
        dispatch(FJActionVoiceCloning.setCreateCloneStatusAction(FJConstant.HISTORY_LIST));
    };

    const _deleteAudio = () => {
        dispatch(FJActionVoiceCloning.resetAction());
    };

    const _openRecord = () => {
        dispatch(FJActionModal.showRecordModalInCreateCloneAction());
    };

    const _onBack = () => {
        dispatch(FJActionVoiceCloning.setIsUploadingAction(false));
        _goHistory();
    };

    return (
        <FJCreateVoiceCloning
            createCloneStatus={createCloneStatus}
            profileId={profileId}
            voiceName={voiceName}
            selectedLang={selectedLang}
            audioUrl={audioUrl}
            audioName={audioName}
            previewAudioUrl={previewAudioUrl}
            uploadAudioInVoiceClone={_uploadAudioInVoiceClone}
            onChangeVoiceName={_onChangeVoiceName}
            onChangeProfile={_onChangeProfile}
            onChangeLang={_onChangeLang}
            onGenerate={_onGenerate}
            goHistory={_goHistory}
            deleteAudio={_deleteAudio}
            openRecord={_openRecord}
            onBack={_onBack}
            hasHistoryList={hasHistoryList}
            taskStatus={taskStatus}
            isProjectLoading={isProjectLoading}
            creditNumber={creditNumber}
            freeNumCreationOfVoiceClone={freeNumCreationOfVoiceClone}
            isUploading={isUploading}
        />
    );
};
export default FJCreateVoiceCloningContainer;
